
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import CelebrationIcon from '@mui/icons-material/Celebration';
import GroupWorkIcon from '@mui/icons-material/GroupWork';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import TtkList from './TtkList';
const VintageCarTTK = ({ data }) => {
    return (
        <>

            <div className="row">
                <div className="col-md-12">
                    <div className='row mb-2'>
                        <div className='col-md-3'>
                            <p> <WorkspacePremiumIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Working Since :</b>&nbsp;<TtkList data={data?.workingSince} /></p>
                        </div>
                        <div className='col-md-3'>
                            <p> <CelebrationIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Vintage Cars Services :</b>&nbsp;<TtkList data={data?.vintageCarsServices} /></p>
                        </div>
                        <div className='col-md-3'>
                            <p ><GroupWorkIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b> Area Of Working :</b>&nbsp;<TtkList data={data?.areaOfWorking} /></p>
                        </div>
                        <div className='col-md-3'>
                            <p> <DirectionsCarIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Seat Available in Cars :</b>&nbsp;<span>{data?.seatAvailable}</span></p>
                        </div>
                    </div>
                    <div className='row mb-2'>
                        <div className='col-md-3'>
                            <p> <MonetizationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Starting Price:</b>&nbsp;<span>{data?.PiecePrice}</span></p>
                        </div>
                        <div className='col-md-3'>
                            <p><DirectionsCarIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Vintage Cars Names & Modals:</b>&nbsp;<TtkList data={data?.vintageCarsName} /></p>
                        </div>
                    </div>
                </div>
            </div>

        </>

    )
}

export default VintageCarTTK